import React, { useState } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import {
    Text,
    StyledCard,
    StyledCardContent,
    Tag,
    CallingIcon,
    AvatarGroup,
    Avatar,
    CopyIcon,
    FilledIconButton,
} from '../../index';

import { SESSION_COLORS, SESSION_TYPE, SMALL_SESSION_TYPE } from '../../../constant';

export const SessionCard = ({ data, onClick, small, showProvider, onDuplicate, isMe }) => {
    const [today] = useState(dayjs());

    return (
        <StyledCard
            style={{
                padding: '12px 15px',
                cursor: onClick ? 'pointer' : 'default',
                height: 'max-content',
                minHeight: '115px',
            }}
            onClick={onClick}
            $borderColor={small ? 'gray6' : 'white'}
        >
            <StyledCardContent
                style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    rowGap: '10px',
                }}
            >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                    <Tag style={{ height: '21px' }} $backgroundColor={SESSION_COLORS[data.type]}>
                        <Text
                            $medium
                            $fontSize="10px"
                            $color="white"
                            style={{ textTransform: 'uppercase ' }}
                        >
                            {small ? SMALL_SESSION_TYPE[data.type] : SESSION_TYPE[data.type]}
                        </Text>
                    </Tag>
                    {data.isOnline && (
                        <Tag
                            style={{ height: '21px', padding: '1px 10px', justifySelf: 'end' }}
                            $backgroundColor="green5"
                            $borderColor="green3"
                        >
                            <CallingIcon />

                            <Text $color="green3" $fontSize="10px" style={{ marginLeft: '5px' }}>
                                ONLINE NOW
                            </Text>
                        </Tag>
                    )}
                    {onDuplicate && data.type !== 'open' && (
                        <FilledIconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                onDuplicate();
                            }}
                            $backgroundColor="green"
                            style={{ margin: 0, width: '32px', height: '32px', justifySelf: 'end' }}
                        >
                            <CopyIcon fill="white" />
                        </FilledIconButton>
                    )}
                </div>
                <div>
                    <Text $fontSize="14px" $ellipsis>
                        {data?.name}
                    </Text>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: small ? 'flex-start' : 'center',
                            justifyContent: 'space-between',
                            flexDirection: small ? 'column' : 'row',
                            rowGap: '10px',
                            columnGap: '10px',
                            minHeight: '35px',
                        }}
                    >
                        <Text $color="gray2" $fontSize="12px">
                            {`${
                                dayjs(data.date || data.startDate).isSame(today, 'day')
                                    ? 'Today'
                                    : dayjs(data.date || data.startDate).format('DD MMM YYYY')
                            }, ${today
                                .set({
                                    hour: data.startTime.split(':')[0],
                                    minute: data.startTime.split(':')[1],
                                })
                                .format('HH:mm')} - ${today
                                .set({
                                    hour: data.endTime.split(':')[0],
                                    minute: data.endTime.split(':')[1],
                                })
                                .format('HH:mm')}`}
                        </Text>
                        <div
                            style={{
                                // width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent:
                                    data.cancelled === true ? 'space-between' : 'flex-end',
                            }}
                        >
                            {data.cancelled === true && (
                                <Text $color="pink" $fontSize="10px">
                                    Cancelled
                                </Text>
                            )}
                            <AvatarGroup
                                data={data.patients}
                                style={{ alignSelf: small ? 'flex-end' : 'auto' }}
                            />
                        </div>
                    </div>
                </div>
                {showProvider && (
                    <div
                        style={{
                            display: 'flex',
                            columnGap: '10px',
                            alignItems: 'center',
                            borderTop: '1px solid #EAEEFB',
                            paddingTop: '7px',
                        }}
                    >
                        <Avatar
                            src={data?.staff?.user?.avatar?.url}
                            alt={data?.staff?.user?.fullname}
                            $avatarSize="30px"
                        />
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div
                                style={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}
                            >
                                <Text $color="gray1" $fontSize="12px">
                                    {data?.staff?.user?.fullname}
                                </Text>
                                {isMe && (
                                    <Text $color="gray3" $fontSize="12px">
                                        (Me)
                                    </Text>
                                )}
                            </div>
                            <Text $color="gray1" $fontSize="10px">
                                {data?.staff?.hospital?.name}
                            </Text>
                        </div>
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

SessionCard.propTypes = {
    data: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    small: PropTypes.bool,
    showProvider: PropTypes.bool,
    onDuplicate: PropTypes.func,
    isMe: PropTypes.bool,
};
